<template>

  <div>
    <div class="uk-grid uk-margin-remove gap-4 uk-child-width-expand@s">

      <div class="uk-padding-remove">
        <div class="uk-form-control uk-form-control-large">
          <span class="uk-form-icon uk-form-icon-flip" uk-icon="search"></span>
          <input type="search" :placeholder="sfModel.BackgroundHint" class="uk-input uk-box-shadow-medium" v-model="searchQuery" @change="filterChange" aria-autocomplete="both"/>
        </div>
      </div>

      <div class="uk-padding-remove">
        <input-checkboxes
            class="uk-form-control uk-form-control-large"
            v-model="selectedCategories"
            :key="selectedCategories"
            @change="filterChange"
            :options="categories"
            :optionLabelKey="optionLabelKey"
            :optionChildrenKey="optionChildrenKey"
            :label="l('Category')"
            name="categories"
        />
      </div>

      <div class="uk-padding-remove">
        <input-checkboxes
            class="uk-form-control uk-form-control-large"
            v-model="selectedResourceTypes"
            :key="selectedResourceTypes"
            @change="filterChange"
            :options="resourceTypes"
            :optionLabelKey="optionLabelKey"
            :optionChildrenKey="optionChildrenKey"
            :label="l('ResourceType')"
            name="resource-type"
        />
      </div>

    </div>
  </div>

</template>
<script setup>
import {onMounted, ref} from 'vue'
import InputCheckboxes from "./input-checkboxes.vue";
import {searchResults} from "./index";
import {sfUtil} from "../../util";

const props = defineProps({
  sfModel: Object,
  taxonomies: Object,
})

const l = window.l

let taxonomies = {...props.taxonomies}
let categories = taxonomies['categories']
let resourceTypes = taxonomies['resourceTypes']

let searchQuery = ref('')
let selectedCategories = ref(new Set());
let selectedResourceTypes = ref(new Set());

let initialResultsHtml = null

const {
  optionLabelKey,
  optionValueKey,
  optionChildrenKey,
  getSearchParams,
  filterChildren,
  objectByValueKeys,
  findSearchResultsContainer
} = sfUtil.useBaseSearch();

const searchResultsContainer = findSearchResultsContainer()

onMounted(() => {
  window.addEventListener('popstate', () => {
    updateSearchResults()
  })

  if (searchResultsContainer && !sfUtil.hasActiveFiltering()) {
    initialResultsHtml = searchResultsContainer.innerHTML
  }
})

let initFilterState = () => {
  let searchParams = getSearchParams()
  searchQuery.value = searchParams.get('searchQuery')
  selectedCategories.value = objectByValueKeys(new Set(searchParams.get('Categories')?.split(',')), categories)
  selectedResourceTypes.value = objectByValueKeys(new Set(searchParams.get('resource-type')?.split(',')), resourceTypes)
}

window.addEventListener('popstate', () => {
  initFilterState()
})

initFilterState()

let filterChange = () => {

  const url = new URL(window.location);

  let categoriesSearch = [...filterChildren(categories, selectedCategories.value)].map(v => v[optionValueKey]).join(',')
  let resourceTypesSearch = [...selectedResourceTypes.value].map(v => v[optionValueKey]).join(',')

  if (categoriesSearch) {
    url.searchParams.set('Categories', categoriesSearch)
  } else {
    url.searchParams.delete('Categories')
  }

  if (resourceTypesSearch) {
    url.searchParams.set('resource-type', resourceTypesSearch)
  } else {
    url.searchParams.delete('resource-type')
  }

  if (resourceTypesSearch || categoriesSearch || searchQuery.value) {
    url.searchParams.set('searchQuery', searchQuery.value || '')

    url.searchParams.set('language', props.sfModel['Language'])
  } else {
    url.searchParams.delete('searchQuery')

    url.searchParams.delete('language')
  }

  if (url.searchParams.has('searchQuery')) {
    url.searchParams.set('indexCatalogue', props.sfModel['IndexCatalogue'])
  } else {
    url.searchParams.delete('indexCatalogue')
  }


  url.pathname = url.pathname.replace(sfUtil.sfPathnamePagingRegex, '')

  url.searchParams.delete('page')

  window.history.pushState({}, '', url);

  updateSearchResults()
}

let updateSearchResults = () => {
  initSearchResults()
  document.dispatchEvent(new Event('searchPredicateChanged'))
}

let searchResultsApp = null

let initSearchResults = () => {
  if (searchResultsApp) return
  searchResultsApp = Vue.createApp(searchResults, {initialResultsHtml})
  searchResultsApp.mount(searchResultsContainer)
  window.searchResultApp = searchResultsApp
}

</script>
